import { PaginationV2 } from "./Pagination";

export class CourierData {
  courierId = 0;
  courierName = "";
  courierPhone = "";
  startTime = "";
  endTime = "";

  constructor(fields?: Partial<CourierData>) {
    Object.assign(this, fields);
  }
}

export class ManageArea {
  uid = "";
  areaName = "";
  totalGeoAddress = 0;
  couriers: CourierData[] = [];
  dedicatedShipment = "";
  createdAt = "";
  updatedAt = "";
  createdBy = "";
  updatedBy = "";

  constructor(fields?: Partial<ManageArea>) {
    Object.assign(this, fields);
  }
}

export class ManageAreaData {
  pagination = new PaginationV2();
  list = [] as ManageArea[];

  constructor(fields?: Partial<ManageAreaData>) {
    Object.assign(this, fields);
  }
}

export class ResponseSummaryGeoAddress {
  assigned = 0;
  unassigned = 0;

  constructor(fields?: Partial<ResponseSummaryGeoAddress>) {
    Object.assign(this, fields);
  }
}

export class ResponseSummaryGeoAddressData {
  data = new ResponseSummaryGeoAddress();

  constructor(fields?: Partial<ResponseSummaryGeoAddressData>) {
    Object.assign(this, fields);
  }
}

// entities for transfer area
export class Shift {
  courierId = 0;
  courierName = "";
  startTime = "";
  endTime = "";

  constructor(fields?: Partial<Shift>) {
    Object.assign(this, fields);
  }
}

export class ResponseTransferArea {
  uid = "";
  areaName = "";
  geoAddressIds = [] as number[];
  geoAddresses = [] as GeoAddress[];
  shifts = [] as Shift[];

  constructor(fields?: Partial<ResponseTransferArea>) {
    Object.assign(this, fields);
  }
}

export class ResponseTransferAreaData {
  data = new ResponseTransferArea();

  constructor(fields?: Partial<ResponseTransferAreaData>) {
    Object.assign(this, fields);
  }
}

export class AvailableCourierEntity {
  id = 0;
  name = "";
  phoneNumber = "";
  email = "";

  constructor(fields?: Partial<AvailableCourierEntity>) {
    Object.assign(this, fields);
  }
}

export class CourierDataShift {
  id = 0;
  name = "";
  phoneNumber = "";
  email = "";
  displayName = ""
  
  constructor(fields?: Partial<CourierDataShift>) { Object.assign(this, fields);
  }
}


export class AvailableCourierList {
  pagination = new PaginationV2();
  list = [] as AvailableCourierEntity[];

  constructor(fields?: Partial<AvailableCourierList>) {
    Object.assign(this, fields);
  }
}
export class GeoAddress {
  id = 0;
  geoAddressId = 0;
  villageName = "";
  subDistrictName = "";
  districtName = "";
  provinceName = "";
  dedicatedShipment = "";

  constructor(fields?: Partial<GeoAddress>) {
    Object.assign(this, fields);
  }
}

export class GeoAddressArea {
  provinceName = "";
  districtName = "";
  subDistrictName = "";
  villageName = "";
  geoAddressId = 0;
  areaId = 0;
  children: GeoAddressArea[] = [];
  isHidden = false;

  constructor(fields?: Partial<GeoAddressArea>) {
    Object.assign(this, fields);
  }

  get name() {
    return this.villageName || this.subDistrictName || this.districtName || this.provinceName;
  }

  get labelName() {
    return this.provinceName || this.districtName || this.subDistrictName || this.villageName;
  }

  get isHaveChildren() {
    return !!this.children.length
  }

  get isDisabled() {
    if (this.areaId) return true;
    return false;
  }

  isChecked(geoAddressIds: number[]): boolean {
    if (this.geoAddressId) return geoAddressIds.includes(this.geoAddressId);
    if (this.isHaveChildren) {
      return this.children.every((ga) => ga.isChecked(geoAddressIds));
    }
    return false;
  }
}

export class ShiftRow {
  id: string;
  startTime: string;
  endTime: string;
  startTimeEditable?: boolean;
  endTimeEditable?: boolean;
  endTimeExpand?: boolean;
  selectedEndTime?: { name: string; value: string };
  courierId: number;
  courierName: string;
  selectedCourier: CourierDataShift;
  courierList: any[];
  courierSearchKeyword?: string;
  courierCurrentPage: number;
  courierHasMore: boolean;
  courierIsLoading: boolean;
  courierError?: string;
  endTimeError?: string;

  constructor(data?: Partial<ShiftRow>) {
    this.id = data?.id || "";
    this.startTime = data?.startTime || "";
    this.endTime = data?.endTime || "";
    this.startTimeEditable = data?.startTimeEditable || false;
    this.endTimeEditable = data?.endTimeEditable || false;
    this.endTimeExpand = data?.endTimeExpand || false;
    this.selectedEndTime = data?.selectedEndTime || { name: "", value: "" };
    this.courierId = data?.courierId || 0;
    this.courierName = data?.courierName || "";
    this.selectedCourier = data?.selectedCourier || new CourierDataShift();
    this.courierList = data?.courierList || [];
    this.courierSearchKeyword = data?.courierSearchKeyword || "";
    this.courierCurrentPage = data?.courierCurrentPage || 1;
    this.courierHasMore = data?.courierHasMore !== undefined ? data.courierHasMore : true;
    this.courierIsLoading = data?.courierIsLoading || false;
    this.courierError = data?.courierError || "";
    this.endTimeError = data?.endTimeError || "";
  }
}

// entities for transfer area
export class GeoAddressTransferArea {
  geoAddressId = 0;
  provinceName = "";
  districtName = "";
  subDistrictName = "";
  villageName = "";

  constructor(fields?: Partial<GeoAddress>) {
    Object.assign(this, fields);
  }
}

export class CreateAreaPayload {
  areaName = "";
  geoAddressIds: number[] = [];
  shifts: ShiftRow[] = [];

  constructor(fields?: Partial<CreateAreaPayload>) {
    Object.assign(this, fields);
  }
}


export class DetailShifts {
  courierId = 0;
  courierName = "";
  startTime = "";
  endTime = "";

  constructor(fields?: Partial<DetailShifts>) {
    Object.assign(this, fields);
  }
}

export class DetailGeoAddresses {
  geoAddressId = 0;
  villageName = "";
  subDistrictName = "";
  districtName = "";
  provinceName = "";

  constructor(fields?: Partial<DetailGeoAddresses>) {
    Object.assign(this, fields);
  }
}

export class DetailPartnerAreaDedicated {
  uid = "";
  areaName = "";
  geoAddressIds: Array<number> = [];
  geoAddresses: DetailGeoAddresses[] = [];
  shifts: DetailShifts[] = [];

  constructor(fields?: Partial<DetailPartnerAreaDedicated>) {
    Object.assign(this, fields);
  }
}

export class UpdatePartnerAreaDedicated {
  areaName = "";
  geoAddressIds: Array<number> = [];
  shifts: DetailShifts[] = [];

  constructor(fields?: Partial<UpdatePartnerAreaDedicated>) {
    Object.assign(this, fields);
  }
}
